export const WRITE_RESULT = {
  success: 'success',
  error: 'error',
  unexpected: 'unexpected'
};
